import { render, staticRenderFns } from "./deviceData.vue?vue&type=template&id=c92724e4&scoped=true&"
import script from "./deviceData.vue?vue&type=script&lang=js&"
export * from "./deviceData.vue?vue&type=script&lang=js&"
import style0 from "./deviceData.vue?vue&type=style&index=0&id=c92724e4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c92724e4",
  null
  
)

export default component.exports